module.exports = __webpack_public_path__ + "img/02.bdb2c5eb.png";